import BackendService from "../../../backend/controller/BackendService";
import LlmConversationMessage, { LlmMessageSender } from "../../../conversation/model/LlmConversationMessage";
import DebugModel from "../../../debug/model/DebugModel";
import PlayerModel from "../../../player/model/PlayerModel";
import ConversationReflection from "../../model/ConversationReflection";
import ConversationReflectionMessage, { ReflectionMessageSender } from "../../model/ConversationReflectionMessage";
import ConversationReflectionState from "./ConversationReflectionState";

export default class EndingTurnConversationReflectionState extends ConversationReflectionState {
    /**
     * 
     * @param {string} chapterId
     * @param {ConversationReflection} conversation 
     * @param {BackendService} backendService 
     * @param {PlayerModel} playerModel
     * @returns {Promise<ConversationReflectionState>}
     */
    async execute(chapterId, conversation, backendService, playerModel) {
        try {
            // Generate last reflection message.
            const conversationReflectionResponse = await backendService.endOfConversationReflection({
                chapterId: chapterId,
                conversationId: conversation.id,
                conversationHistory: conversation.conversationHistoryForLLM,
                playerName: playerModel.getTrimmedPlayerName(),
            });

            conversation.addConversationHistory({
                llmConversationMessages: [new LlmConversationMessage(LlmMessageSender.ASSISTANT, conversationReflectionResponse.message)],
                gameConversationMessages: [new ConversationReflectionMessage(ReflectionMessageSender.COACH, conversationReflectionResponse.message)],
            });

            // Actually end the conversation.
            conversation.end();

            // Log the reflection summary.
            if (ranj.DEBUG || DebugModel.debugContent) {
                console.log(`%c📙 Reflection summary:\n${conversationReflectionResponse.summary}`, 'background: #ffda7d; font-size: 16px; color: black;');
            }
            conversation.summary = conversationReflectionResponse.summary;

            const nextState = null; // There is no next state.
            return Promise.resolve(nextState);
        } catch (error) {
            console.error(`[${EndingTurnConversationReflectionState.name}] Error: `, error);
            return Promise.reject(error);
        }
    }
}